<template>
	<div class="projetovalidacao">
		<loader object="#df3e46" v-show="progress" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0" objectbg="#0d0c0d" opacity="50" name="circular"></loader>
		<div class="container-fluid">
			<ol class="breadcrumb-arrow">
				<li>
					<a href="/home"><i class="fa fa-home"></i></a>
					<a href="/notificacao"> Notificações</a>
				</li>
			</ol>
		</div>

		<div class="container-fluid mt-2">
			<form class=" mt-2">
				<div class="container-fluid mt-2">
					<div class="col-12 text-right mb-2 mt--4">
						<el-tooltip content="Excluir notificações selecionadas" placement="top">
							<button type="button" class="btn btn-outline-secondary descricao mr-2"
									@click="excluirNotificacao">
								<i class="far fa-trash-alt"></i>
							</button>
						</el-tooltip>
					</div>

					<!--------- Objetivos / OKR -------->
					<div class="card">
						<div class="card-header"> 
							<div class="row">
								<div class="col clickable" data-toggle="collapse" data-target="#collapseOkr" aria-expanded="true" aria-controls="collapseOkr">
									<i class="fas fa-bullseye mr-2"></i>Objetivos / OKR {{ (listaNotificacaoOkr.length == 0) ? '' : '('+ listaNotificacaoOkr.length +')' }}
								</div>
								<div class="col-1 text-right mt-1 mr-1">
									<input class="form-check-input" v-show="listaNotificacaoOkr.length > 0" type="checkbox" 
										value="true" @change="selecionarTodosOkr" v-model="checkTodosOkr">
								</div>
							</div>
						</div>
						<div class="card-body caixa-scroll collapse show" id="collapseOkr">

							<div class="row fundo" v-for="(notificacao, index) in listaNotificacaoOkr" :key="notificacao.idnotificacao">
								<div class="col-1 central mt-2">
									<i :class="notificacao.icone"></i>
								</div>
								<div class="col-1 central mt-2">
									<img :src="notificacao.agente.avatar" :title="notificacao.agente.nome" width="35" class="rounded-circle mt-n1">
								</div>
								<div class="col">
								
									<div class="row">
										<div class="col">
											<span v-if="!notificacao.lido" class="badge badge-pill badge-warning mr-1 descricaoBadge">novo</span>
											<div v-if="notificacao.descricao">{{ notificacao.descricao }}</div>
										</div>
									</div>
									<div class="row descricao">
										<div class="col-12 text-right text-muted">
											{{ notificacao.dataHora }} - {{ notificacao.tempoDataHora }}
										</div>
									</div>
								</div>
								<div class="col-1 text-right mt-2">
									<input type="checkbox" id="notOkr" :value="notificacao.idnotificacao" v-model="checkNotOkr" />
								</div>
							</div>

						</div>
					</div>

					<!--------- Projeto -------->
					<div class="card">
						<div class="card-header"> 
							<div class="row">
								<div class="col clickable" data-toggle="collapse" data-target="#collapseProjeto" aria-expanded="true" aria-controls="collapseProjeto">
									<i class="far fa-calendar-check mr-2"></i>Projeto {{ (listaNotificacaoP.length == 0) ? '' : '('+ listaNotificacaoP.length +')' }}
								</div>
								<div class="col-1 text-right mt-1 mr-1">
									<input class="form-check-input" v-show="listaNotificacaoP.length > 0" type="checkbox" 
										value="true" @change="selecionarTodosProjeto" v-model="checkTodosProjeto">
								</div>
							</div>
						</div>
						<div class="card-body caixa-scroll collapse show" id="collapseProjeto">

							<div class="row fundo" v-for="(notificacao, index) in listaNotificacaoP" :key="notificacao.idnotificacao">
								<div class="col-1 central mt-2">
									<i :class="notificacao.icone"></i>
								</div>
								<div class="col-1 central mt-2">
									<img :src="notificacao.agente.avatar" :title="notificacao.agente.nome" width="35" class="rounded-circle mt-n1">
								</div>
								<div class="col">
								
									<div class="row">
										<div class="col">
											<span v-if="!notificacao.lido" class="badge badge-pill badge-warning mr-1 descricaoBadge">novo</span>
											<strong class="clickable" @click="abrirModalProjeto(notificacao.projeto)">{{ notificacao.projeto.titulo }}</strong>
										</div>
									</div>
									<div class="row descricao">
										<div class="col">
											{{ notificacao.descricao }}
										</div>
										<div class="col-4 text-right text-muted">
											{{ notificacao.dataHora }} - {{ notificacao.tempoDataHora }}
										</div>
									</div>
								</div>
								<div class="col-1 text-right mt-2">
									<input type="checkbox" id="notProjeto" :value="notificacao.idnotificacao" v-model="checkNotProjeto" />
								</div>
							</div>

						</div>
					</div>

					<!--------- Atividade -------->
					<div class="card">
						<div class="card-header"> 
							<div class="row">
								<div class="col clickable" data-toggle="collapse" data-target="#collapseAtividade" aria-expanded="false" aria-controls="collapseAtividade">
									<i class="fas fa-calendar-check mr-2"></i>Atividade {{ (listaNotificacaoA.length == 0) ? '' : '('+ listaNotificacaoA.length +')' }}
								</div>
								<div class="col-1 text-right mt-1 mr-1">
									<input class="form-check-input" v-show="listaNotificacaoA.length > 0" type="checkbox" 
										value="true" @change="selecionarTodosAtividade" v-model="checkTodosAtividade">
								</div>
							</div>
						</div>
						<div class="card-body caixa-scroll collapse show" id="collapseAtividade">

							<div class="row fundo" v-for="(notificacao, index) in listaNotificacaoA" :key="notificacao.idnotificacao">
								<div class="col-1 central mt-2">
									<i :class="notificacao.icone"></i>
								</div>
								<div class="col-1 central mt-2">
									<img :src="notificacao.agente.avatar" :title="notificacao.agente.nome" width="35" class="rounded-circle mt-n1">
								</div>
								<div class="col">
								
									<div class="row">
										<div class="col">
											<span v-if="!notificacao.lido" class="badge badge-pill badge-warning mr-1 descricaoBadge">novo</span>
											<strong class="clickable" @click="abrirModalAtividade(notificacao.atividade)">{{ notificacao.atividade.titulo }}</strong>
										</div>
									</div>
									<div class="row descricao">
										<div class="col">
											{{ notificacao.descricao }}
										</div>
										<div class="col-4 text-right text-muted">
											{{ notificacao.dataHora }} - {{ notificacao.tempoDataHora }}
										</div>
									</div>
								</div>
								<div class="col-1 text-right mt-2">
									<input type="checkbox" id="notAtividade" :value="notificacao.idnotificacao" v-model="checkNotAtividade" />
								</div>
							</div>

						</div>
					</div>

					<!--------- Tarefa -------->
					<div class="card">
						<div class="card-header"> 
							<div class="row">
								<div class="col clickable" data-toggle="collapse" data-target="#collapseTarefa" aria-expanded="false" aria-controls="collapseTarefa">
									<i class="far fa-calendar-alt mr-2"></i>Tarefa {{ (listaNotificacaoT.length == 0) ? '' : '('+ listaNotificacaoT.length +')' }}
								</div>
								<div class="col-1 text-right mt-1 mr-1">
									<input class="form-check-input" v-show="listaNotificacaoT.length > 0" type="checkbox" 
										value="true" @change="selecionarTodosTarefa" v-model="checkTodosTarefa">
								</div>
							</div>
						</div>
						<div class="card-body caixa-scroll collapse show" id="collapseTarefa">

							<div class="row fundo" v-for="(notificacao, index) in listaNotificacaoT" :key="notificacao.idnotificacao">
								<div class="col-1 central mt-2">
									<i :class="notificacao.icone"></i>
								</div>
								<div class="col-1 central mt-2">
									<img :src="notificacao.agente.avatar" :title="notificacao.agente.nome" width="35" class="rounded-circle mt-n1">
								</div>
								<div class="col">
								
									<div class="row">
										<div class="col">
											<span v-if="!notificacao.lido" class="badge badge-pill badge-warning mr-1 descricaoBadge">novo</span>
											<strong class="clickable" @click="abrirModalAtividade(notificacao.atividade)">{{ notificacao.atividade.titulo }}</strong>
										</div>
									</div>
									<div class="row descricao">
										<div class="col">
											{{ notificacao.descricao }}
										</div>
										<div class="col-4 text-right text-muted">
											{{ notificacao.dataHora }} - {{ notificacao.tempoDataHora }}
										</div>
									</div>
								</div>
								<div class="col-1 text-right mt-2">
									<input type="checkbox" id="notTarefa" :value="notificacao.idnotificacao" v-model="checkNotTarefa" />
								</div>
							</div>

						</div>
					</div>

					<!--------- Outras -------->
					<div class="card">
						<div class="card-header"> 
							<div class="row">
								<div class="col clickable" data-toggle="collapse" data-target="#collapseOutros" aria-expanded="false" aria-controls="collapseOutros">
									<i class="far fa-sticky-note mr-2"></i>Outras {{ (listaNotificacaoO.length == 0) ? '' : '('+ listaNotificacaoO.length +')' }}
								</div>
								<div class="col-1 text-right mt-1 mr-1">
									<input class="form-check-input" v-show="listaNotificacaoO.length > 0" type="checkbox" 
										value="true" @change="selecionarTodosOutra" v-model="checkTodosOutra">
								</div>
							</div>
						</div>
						<div class="card-body caixa-scroll collapse show" id="collapseOutros">

							<div class="row fundo" v-for="(notificacao, index) in listaNotificacaoO" :key="notificacao.idnotificacao">
								<div class="col-1 central mt-2">
									<i :class="notificacao.icone"></i>
								</div>
								<div class="col-1 central mt-2">
									<img :src="notificacao.agente.avatar" :title="notificacao.agente.nome" width="35" class="rounded-circle mt-n1">
								</div>
								<div class="col">
								
									<div class="row">
										<div class="col">
											<span v-if="!notificacao.lido" class="badge badge-pill badge-warning mr-1 descricaoBadge">novo</span>
											<strong>{{ notificacao.projeto.titulo }}</strong>
										</div>
									</div>
									<div class="row descricao">
										<div class="col">
											{{ notificacao.descricao }}
										</div>
										<div class="col-4 text-right text-muted">
											{{ notificacao.dataHora }} - {{ notificacao.tempoDataHora }}
										</div>
									</div>
								</div>
								<div class="col-1 text-right mt-2">
									<input type="checkbox" id="notOutra" :value="notificacao.idnotificacao" v-model="checkNotOutra" />
								</div>
							</div>

						</div>
					</div>
				</div>
			</form>
		</div>

		<modal id="modalProj" :show.sync="modals.modalProjeto" size="xl">
			<div class="text-right iconeFecharModal">
				<span @click="closeModalProjeto()" class="pull-right clickable close-icon" data-effect="fadeOut"><i class="fa fa-times"></i></span>
			</div>
			<Projeto v-if="modals.modalProjeto" 
				@fechar-projeto="closeModalProjeto"
				@abrir-atividade="abrirModalAtividade"
				:projetoSelecionado=projetoModal />
		</modal> 
		
		<modal id="modalAtv" :show.sync="modals.modalAtividade" size="xl">
			<div class="text-right iconeFecharModal">
				<span @click="closeModalAtividade()" class="pull-right clickable close-icon" data-effect="fadeOut"><i class="fa fa-times"></i></span>
			</div>
			<Atividade v-if="modals.modalAtividade" 
				@atualizar-lista="filtrarAtividade"
				@fechar-atividade="closeModalAtividade"
				@abrir-projeto="abrirModalProjeto"
				:atividadeSelecionada=atividadeModal />
		</modal>
	</div>
</template>

<script>
import Atividade from "@/components/Atividade.vue";
import Projeto from "@/components/Projeto.vue";

export default {
	components: {
		Atividade,
		Projeto
	},
	created() {
		this.carregarNotificacao();
	},
	data() {
		return {
			progress: true,
			checkTodosOkr: false,
			checkNotOkr: [],
			checkTodosProjeto: false,
			checkNotProjeto: [],
			checkTodosAtividade: false,
			checkNotAtividade: [],
			checkTodosTarefa: false,
			checkNotTarefa: [],
			checkTodosOutra: false,
			checkNotOutra: [],
			listaNotificacaoOkr: [],
			listaNotificacaoP: [],
			listaNotificacaoA: [],
			listaNotificacaoT: [],
			listaNotificacaoO: [],
			modals: {
				modalProjeto: false,
				modalAtividade: false,
			},
			projetoModal: null,
			atividadeModal: null,
		};
	},
	methods: {
		carregarNotificacao() {
			this.progress = true;
			this.$clubApi.get("/notificacao").then((response) => {
				const listaNotificacao = response.data.object;
				this.listaNotificacaoOkr = listaNotificacao.filter((notif) => {
					return (notif.tipoNotificacao == 5);
				});
				this.listaNotificacaoP = listaNotificacao.filter((notif) => {
					return (notif.tipoNotificacao == 1);
				});
				this.listaNotificacaoA = listaNotificacao.filter((notif) => {
					return (notif.tipoNotificacao == 2);
				});
				this.listaNotificacaoT = listaNotificacao.filter((notif) => {
					return (notif.tipoNotificacao == 3);
				});
				this.listaNotificacaoO = listaNotificacao.filter((notif) => {
					return (notif.tipoNotificacao == 4);
				});
				this.$clubApi.post("/notificacao/lida");
			})
			.catch((error) => {
				this.$toastr.error(error.response.data.msg);
			})
			.finally(() => {
				this.progress = false;
			});
		},
		excluirNotificacao() {
			let listaExclusao = this.checkNotOkr.concat(this.checkNotProjeto).concat(this.checkNotAtividade).concat(this.checkNotTarefa).concat(this.checkNotOutra);
			if (listaExclusao.length == 0) {
				this.$toastr.warning("Nenhuma notificação selecionada!");
				return;
			}
			const options = {
					title: "Exclusão",
					okLabel: "Confirmar",
					cancelLabel: "Não",
				};
				this.$dialogs.confirm('Deseja realmente excluir as notificações selecionadas?', options)
					.then((res) => {
						if (res.ok) {
							this.progress = true;
							this.$clubApi.post("/notificacao/exclusao", listaExclusao).then(() => {
								this.$toastr.success("Notificação(ões) excluída(s) com sucesso");
								this.carregarNotificacao();
							})
							.catch((error) => {
								this.$toastr.error(error.response.data.msg);
							})
							.finally(() => {
								this.progress = false;
							});
						}
					});
		},
		selecionarTodosOkr() {
			if (this.checkTodosOkr) {
				this.listaNotificacaoOkr.forEach((notificacao) => {
					this.checkNotOkr.push(notificacao.idnotificacao);
				});
			} else {
				this.checkNotOkr = [];
			}
		},
		selecionarTodosProjeto() {
			if (this.checkTodosProjeto) {
				this.listaNotificacaoP.forEach((notificacao) => {
					this.checkNotProjeto.push(notificacao.idnotificacao);
				});
			} else {
				this.checkNotProjeto = [];
			}
		},
		selecionarTodosAtividade() {
			if (this.checkTodosAtividade) {
				this.listaNotificacaoA.forEach((notificacao) => {
					this.checkNotAtividade.push(notificacao.idnotificacao);
				});
			} else {
				this.checkNotAtividade = [];
			}
		},
		selecionarTodosTarefa() {
			if (this.checkTodosTarefa) {
				this.listaNotificacaoT.forEach((notificacao) => {
					this.checkNotTarefa.push(notificacao.idnotificacao);
				});
			} else {
				this.checkNotTarefa = [];
			}
		},
		selecionarTodosOutra() {
			if (this.checkTodosOutra) {
				this.listaNotificacaoO.forEach((notificacao) => {
					this.checkNotOutra.push(notificacao.idnotificacao);
				});
			} else {
				this.checkNotOutra = [];
			}
		},
		abrirModalProjeto(projeto) {
			this.projetoModal = projeto;
			this.modals.modalProjeto = true;
		},
		abrirModalAtividade(atividade) {
			this.atividadeModal = atividade;
			this.modals.modalAtividade = true;
		},
		closeModalAtividade() {
			this.modals.modalAtividade = false;
		},
		closeModalProjeto() {
			this.modals.modalProjeto = false;
		},
	}
}
</script>
<style scoped>
.container-fluid { padding-left: 10px !important; padding-right: 10px !important; }
.clickable {
	cursor: pointer;
}
.central {
	display: inline;
	text-align: center;	
}
.descricao {
	font-size: 12px;
}
.descricaoBadge {
	font-size: 9px;
}
.caixa-scroll {
	max-height: 250px;
    overflow-x: hidden;
    overflow-y: scroll;
    scrollbar-width: thin;
}
.fundo {
	padding: 5px;
	border-radius: 5px;
	border-bottom: 1px #dfdfdf dashed;
}
.fundo:hover {
	background-color: #eeeeee;
}
</style>
